import { action } from "./ac101-app";
import { Tooltip } from "bootstrap";

export class SearchModalForm extends HTMLElement {
  updated() {
    this.querySelector("form").setAttribute("action", action.get() ?? "");
  }

  get form() {
    return this.querySelector<HTMLFormElement>('form');
  }
  #tooltip: Tooltip;
  connectedCallback() {
    this.#tooltip = new Tooltip(this.querySelector('button[type="submit"]'), {
      placement: "top",
      title: "Please enter a location by postcode, suburb, region or name",
      customClass: "ac101-tooltip",
      html: true,
    });
    this.#tooltip.disable();
    
    const update = () => this.form.action = action.get() ?? "";
    action.subscribe(update);
    update();
    console.log('connect')
    console.log(this.form);
    this.form.addEventListener('submit', e => {
      if (!this.form.getAttribute("action")) {
        this.#tooltip.enable();
        this.#tooltip.show();
      } else {
        this.#tooltip.hide();
        this.#tooltip.disable();
      }
      console.log('submit')
      if (!this.form.getAttribute("action")) {
        e.preventDefault();
      }
      const data = new FormData(this.form);
      let hasData = false;
      for (const entry of data.entries()) {
        console.log(entry);
        hasData = true;
        break;
      }
      console.log({ hasData });
      if (!hasData) {
        window.location.href = this.form.getAttribute('action');
        e.preventDefault();
      }
    })

    this.form.addEventListener("formdata", (e) => {
      
      if (!e.formData.get("MinPrice")) {
        e.formData.delete("MinPrice");
      }
      if (!e.formData.get("MaxPrice")) {
        e.formData.delete("MaxPrice");
      }
    });
  }
}

customElements.define('ac101-search-modal-form', SearchModalForm);

declare global {
  interface HTMLElementTagNameMap {
    "ac101-search-modal-form": SearchModalForm;
  }
}
